"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var axios_1 = __importDefault(require("axios"));
var ApiUtility_1 = require("./ApiUtility");
var antd_1 = require("antd");
// export const getReceiverRequirements = (recRequirements: ReceiverRequirements, key: AvailableFields): FieldRequirement => {
//     return recRequirements[key]!;
// };
//
// export const getReceiverRequirementsIsRequired = (recRequirements: ReceiverRequirements, key: AvailableFields, defaultIsRequired: boolean): boolean => {
//     if (recRequirements.hasOwnProperty(key)) {
//         const recRequirement = recRequirements[key];
//         if (recRequirement) {
//             return recRequirement.isRequired
//         }
//     }
//     return defaultIsRequired;
// };
//
// export const getReceiverRequirementsLabelWithDefault = (recRequirements: ReceiverRequirements, key: AvailableFields, defaultLabel: React.ReactNode): React.ReactNode => {
//     if (recRequirements.hasOwnProperty(key)) {
//         const recRequirement = recRequirements[key];
//         if (recRequirement && recRequirement.label) {
//             return recRequirement.label
//         }
//     }
//     return defaultLabel;
// };
exports.getFieldRequirements = function (receiverRequirements, key) {
    return receiverRequirements ? receiverRequirements.fieldDefinitions.find(function (field) { return field.key === key; }) : undefined;
};
exports.getFieldLabelOverride = function (receiverRequirements, key, defaultLabel) {
    var fieldRequirement = exports.getFieldRequirements(receiverRequirements, key);
    return fieldRequirement && fieldRequirement.properties.hasOwnProperty("label") ? fieldRequirement.properties.label : defaultLabel;
};
exports.getFieldLabelTooltipOverride = function (receiverRequirements, key, defaultLabelTooltip) {
    var fieldRequirement = exports.getFieldRequirements(receiverRequirements, key);
    if (fieldRequirement && fieldRequirement.properties.hasOwnProperty("handling")) {
        if (fieldRequirement.properties.handling) {
            var handling = JSON.parse(fieldRequirement.properties.handling);
            return handling.helpText ? handling.helpText : defaultLabelTooltip;
        }
        else
            return defaultLabelTooltip;
    }
    else {
        return defaultLabelTooltip;
    }
};
exports.getFieldPlaceholderOverride = function (fieldRequirement, defaultPlaceholder) {
    if (fieldRequirement.properties.handling) {
        var handling = JSON.parse(fieldRequirement.properties.handling);
        return handling.placeholder ? handling.placeholder : defaultPlaceholder;
    }
    return defaultPlaceholder ? defaultPlaceholder : "";
};
exports.getFieldIsRequired = function (receiverRequirements, key, defaultIsRequired) {
    var fieldRequirement = exports.getFieldRequirements(receiverRequirements, key);
    var fieldCardinality = fieldRequirement && fieldRequirement.properties.hasOwnProperty("cardinality") && fieldRequirement.properties.cardinality;
    return fieldCardinality ? cardinalityToRequired(fieldCardinality) || defaultIsRequired : defaultIsRequired;
};
var cardinalityToRequired = function (cardinality) {
    switch (cardinality) {
        case "0..0":
        case "0..1":
            return false;
        case "1..1":
            return true;
        default:
            throw new Error("Cardinality \"" + cardinality + "\" is not supported");
    }
};
exports.handleValueValidation = lodash_1.debounce(function (isoNumber, fieldName, value, rapiBaseUrl, namePath, setValidationStatus, formInstance, callName) {
    if (value.length === 0) {
        setValidationStatus("");
        formInstance.resetFields([namePath]);
    }
    else {
        var searchUrl = rapiBaseUrl + ("/api/v1/requirements/" + isoNumber + "/" + fieldName + "/values/validate?value=" + encodeURIComponent(value));
        setValidationStatus("validating");
        axios_1.default.get(searchUrl, { cancelToken: ApiUtility_1.getCancelToken(callName) })
            .then(function (response) {
            response.data ? setValidationStatus("success") : setValidationStatus("error");
        })
            .catch(function () {
            setValidationStatus("error");
        });
    }
}, 500);
var handleValueSearch = function (searchValue, fieldDefinition, setLoadingValues, loadingValues, receiverRequirements, updateReceiverRequirementsProp, callName, rapiBaseUrl, overwrittenFieldDefinitionKey) {
    if (fieldDefinition.properties.href) {
        var searchUrl = rapiBaseUrl + fieldDefinition.properties.href.replace("%7BtextFilter%7D", encodeURIComponent(searchValue)).replace("%7Boffset%7D", "0").replace("%7Blimit%7D", "15");
        if (!loadingValues) {
            setLoadingValues(true);
        }
        axios_1.default.get(searchUrl, { cancelToken: ApiUtility_1.getCancelToken(callName) })
            .then(function (response) {
            setLoadingValues(false);
            var updatedFieldDefinitions = receiverRequirements.fieldDefinitions.slice();
            var key = overwrittenFieldDefinitionKey ? overwrittenFieldDefinitionKey : fieldDefinition.key;
            var index = updatedFieldDefinitions.findIndex(function (x) { return x.key === key; });
            var updatedFieldDefinition = __assign({}, updatedFieldDefinitions[index], { properties: __assign({}, updatedFieldDefinitions[index].properties, { values: response.data.value }) });
            updatedFieldDefinitions.splice(index, 1, updatedFieldDefinition);
            var newReceiverRequirements = __assign({}, receiverRequirements, { fieldDefinitions: updatedFieldDefinitions });
            updateReceiverRequirementsProp(newReceiverRequirements);
        })
            .catch(function (error) {
            setLoadingValues(false);
        });
    }
};
exports.debouncedHandleSearchValues = lodash_1.debounce(handleValueSearch, 500);
exports.getInput = function (fieldDefinition, namePath, validationCallName, legalIdentifier, formInstance, rapiBaseUrl, receiverRequirements, updateReceiverRequirementsProp, setAccountingCostFieldProps, accountingCostFieldProps, setLoadingAccountingCostValues, loadingAccountingCostValues, setHandlingValidationStatus, allowClearSelect) {
    var handling = null;
    if (fieldDefinition.properties.handling) {
        handling = JSON.parse(fieldDefinition.properties.handling);
    }
    var placeholder = exports.getFieldPlaceholderOverride(fieldDefinition);
    if (handling && handling.shouldBeValidated) {
        return (react_1.default.createElement(antd_1.Input, { onBlur: function (event) {
                exports.handleValueValidation(legalIdentifier, fieldDefinition.name, event.currentTarget.value, rapiBaseUrl, namePath, setHandlingValidationStatus, formInstance, validationCallName);
            }, placeholder: placeholder }));
    }
    else if (fieldDefinition.properties.values) {
        var selectProps = fieldDefinition.properties.hasOwnProperty("href")
            ? {
                showSearch: true,
                filterOption: false,
                onSearch: function (searchValue) {
                    exports.debouncedHandleSearchValues(searchValue, fieldDefinition, setLoadingAccountingCostValues, loadingAccountingCostValues, receiverRequirements, updateReceiverRequirementsProp, "getAccountingCOstValues", rapiBaseUrl);
                },
                loading: loadingAccountingCostValues,
            }
            : {};
        return (react_1.default.createElement(antd_1.Select, __assign({ dropdownMatchSelectWidth: false, allowClear: allowClearSelect }, selectProps, { placeholder: placeholder }), fieldDefinition.properties.values.map(function (op) {
            return react_1.default.createElement(antd_1.Select.Option, { key: op.key, value: op.key }, op.name);
        })));
    }
    else {
        return (react_1.default.createElement(antd_1.Input, { allowClear: allowClearSelect, placeholder: placeholder }));
    }
};
